import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { DataContext } from '../../Context';
import { Modal } from '../../Modal/ReactPortal';
import './card.css';
import CardProductButton from './CardProductButton';

function CardProducts({ id, name, img, price, category, addToCart, descuento, valueFinal, stock }) {

  const { openModal, setOpenModal,setIdProductModal, baseImage, errorDolarAPI} = useContext(DataContext);

  const crearProducto = (nombre, descuento, imagen, id, precio) => {
    let productItem = {
      imagen: imagen,
      descuento: descuento,
      id: id,
      nombre: nombre,
      precio: precio
    }
    addToCart(productItem);

  }
  const onClickButton = (nombre, descuento, imagen, id, precio) => {
    let productItem = {
      imagen: imagen,
      descuento: descuento,
      id: id,
      nombre: nombre,
      precio: precio
    }
      setOpenModal(!openModal);
      setIdProductModal(productItem)
      console.log("Estado:",openModal)

     
    };
  return (
    <div className="card_item">
      <div className="img_container_card">
        <img src={baseImage + img} alt={name} />
      </div>
      {descuento > 0 ? <span className="discount">{descuento}% Off</span> : null}
      <h3>{name}</h3>
      {stock === 0 ? null : descuento > 0 ? <h4>Precio: <strike> {errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(valueFinal)}</strike></h4> : <h4>Precio: AR$ {Intl.NumberFormat('de-DE').format(valueFinal)}</h4>}
      {stock === 0 ? null : descuento > 0 ? <h4>Ahora: {errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(parseInt(valueFinal) - (parseInt(descuento) * parseInt(valueFinal) / 100))} </h4> : null}
      {stock === 0 ? <h4 className='producto_sinstock'>Producto sin Stock</h4> : null}
      <div className="buttons_container_card_product">
        <button className={stock === 0 ? "card_product_button_disabled" : "card_product_button"} disabled={stock === 0 ? true : false} onClick={() => crearProducto(name, descuento, img, id, parseInt(valueFinal) - (parseInt(descuento) * parseInt(valueFinal) / 100))} >
        <i className="fa fa-plus"></i>
        </button>
        {/* <CardProductButton id={id}/> */}
        <Link to={`/productDetails/${id}`}><button className='card_product_button'>Ver Producto</button></Link>
      </div>
    </div>
  )
}

export default CardProducts